(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phm-liver-guide"]) return;
  try {
    
(() => {
  if (window.PHMLiverEditor) { window.PHMLiverEditor.init(document); return; }
  const timers = new Map();
  function init(scope) {
    const roots = scope.matches?.('[data-phm-liver]') ? [scope] : scope.querySelectorAll('[data-phm-liver]');
    roots.forEach(root => {
      if (timers.has(root.id)) clearInterval(timers.get(root.id));
      const incoming = new URLSearchParams(location.search);
      root.querySelectorAll('.product-link').forEach(link => {
        const url = new URL(link.href, location.href);
        ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid'].forEach(key => {
          if (incoming.has(key)) url.searchParams.set(key, incoming.get(key));
        });
        link.href = url.toString();
      });
      root.querySelectorAll('a[href*="#source-"]').forEach(link => {
        link.onclick = () => { const sources = root.querySelector('.sources details'); if (sources) sources.open = true; };
      });
      const clock = root.querySelector('#offer-countdown');
      if (!clock) return;
      let end = Date.parse(root.dataset.offerEnd || '');
      const live = Number.isFinite(end);
      if (!live) {
        const seconds = Math.max(0, Number(root.dataset.previewSeconds) || 0);
        end = Date.now() + seconds * 1000;
        const key = 'phm-liver-preview-' + root.id + '-' + seconds;
        if (!window.Shopify?.designMode) {
          try { const old = Number(sessionStorage.getItem(key)); if (old > 0) end = old; else sessionStorage.setItem(key, String(end)); } catch (_) {}
        }
      } else clock.dateTime = new Date(end).toISOString();
      const update = () => {
        if (!root.isConnected) { clearInterval(timers.get(root.id)); timers.delete(root.id); return; }
        const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        clock.textContent = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(n => String(n).padStart(2,'0')).join(' : ');
        clock.setAttribute('aria-label',(live ? 'Offer countdown: ' : 'Preview countdown: ') + clock.textContent);
        if (!seconds) { clearInterval(timers.get(root.id)); timers.delete(root.id); }
      };
      update(); timers.set(root.id, setInterval(update, 1000));
    });
  }
  window.PHMLiverEditor = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-phm-liver]').forEach(root => { clearInterval(timers.get(root.id)); timers.delete(root.id); });
  });
  document.addEventListener('shopify:block:select', event => {
    event.target.querySelectorAll('details').forEach(detail => { detail.open = true; });
    event.target.scrollIntoView({block:'center',behavior:'auto'});
  });
})();


  } catch(e) { console.error(e); }
})();
})();
